import * as React from 'react';

import {Illustration} from 'shells/illustrations/illustration';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import styles from './revenue-widget-onboarding-info.module.css';

export function RevenueWidgetOnboardingInfo() {
    return (
        <Stack spacing={8}>
            <div className={styles['revenue-widget-illustration']}>
                <Illustration src='revenue-widget' />
            </div>
            <Body isBold={true}>Introducing ‘Revenue’</Body>
            <Body size='small'>
                The revenue widget groups products, quotes, and invoices, and provides the option to
                manually edit your lead’s value.
            </Body>
        </Stack>
    );
}
